<div class="guest-header-container">
  <div class="brandarea">
    <a href="https://www.chargepoint.com" target="new"><img src="assets/images/cpnos/dp/logo_color.png" width="176" height="35"
        alt="ChargePoint" class="logo fltlft"></a>
  </div>
</div>
